import Page from "../../common/page/Page"
import Loader from "../../common/loader/Loader"
// import { useAuth } from "../../data/useAuth"
import style from "./OrderSummary.module.css"
import { useEffect, useState, useMemo } from "react"
import axios from "axios"
import { Link, useNavigate, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { updateCartQty, removeCartItem } from "../../data/CartSlice"
import { useOrderPayment } from "../../common/hook/useOrderPayment"
import { useAuth } from "../../data/useAuth"
import { decodeHtml, decodeAddress } from "../../common/utils/address.util"

const OrderSummary = () => {
  const dispatch = useDispatch()
  // const { user } = useAuth()
  const { data } = useParams()
  const { signOut } = useAuth()
  const { initiatePayment, isPlacingOrder } = useOrderPayment()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [isClicked, setIsClicked] = useState(false)
  const [products, setProducts] = useState([])
  const [addresses, setAddresses] = useState([])
  const [selectedAddressId, setSelectedAddressId] = useState(null)
  const [allowAddress, setAllowAddress] = useState([])
  const [agreedToTerms, setAgreedToTerms] = useState(false)
  const [showTerms, setShowTerms] = useState(false)
  const [charge, setCharge] = useState("")
  const [showInlineAddressForm, setShowInlineAddressForm] = useState(false)
  const [isSubmittingAddress, setIsSubmittingAddress] = useState(false)
  const [addressErrors, setAddressErrors] = useState({})
  const [newAddressData, setNewAddressData] = useState({
    name: "",
    phone_number: "",
    line_1: "",
    line_2: "",
    city: "",
    district: "",
    state: "",
    country: "India",
    pin_code: "",
  })

  const handleAddressInputChange = (e) => {
    const { name, value } = e.target
    setNewAddressData((prev) => ({ ...prev, [name]: value }))
    // Clear error for field being edited
    if (addressErrors[name]) {
      setAddressErrors((prev) => ({ ...prev, [name]: "" }))
    }
  }

  const validateAddressForm = () => {
    const errors = {}
    if (!newAddressData.name.trim()) {
      errors.name = "Full Name is required."
    }
    if (!newAddressData.phone_number.trim()) {
      errors.phone_number = "Phone number is required."
    } else if (!/^\d{10}$/.test(newAddressData.phone_number.trim())) {
      errors.phone_number = "Please enter a valid 10-digit phone number."
    }
    if (!newAddressData.line_1.trim()) {
      errors.line_1 = "Address Line 1 is required."
    }
    if (!newAddressData.line_2.trim()) {
      errors.line_2 = "Address Line 2 is required."
    }
    if (!newAddressData.city.trim()) {
      errors.city = "City is required."
    }
    if (!newAddressData.district.trim()) {
      errors.district = "District is required."
    }
    if (!newAddressData.state) {
      errors.state = "Please select a state."
    }
    if (!newAddressData.pin_code) {
      errors.pin_code = "Pin code is required."
    } else if (isNaN(newAddressData.pin_code) || newAddressData.pin_code.toString().length < 5) {
      errors.pin_code = "Please enter a valid pin code."
    }
    if (!newAddressData.country.trim()) {
      errors.country = "Country is required."
    }

    setAddressErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleInlineAddressSubmit = async (e) => {
    e.preventDefault()
    if (!validateAddressForm()) return

    setIsSubmittingAddress(true)
    try {
      const response = await axios.post("/api/address", newAddressData)
      const addedAddress = decodeAddress(response.data)
      setAddresses((prev) => [...prev, addedAddress])
      setSelectedAddressId(addedAddress.id)
      setShowInlineAddressForm(false)
      setAddressErrors({})
      setNewAddressData({
        name: "",
        phone_number: "",
        line_1: "",
        line_2: "",
        city: "",
        district: "",
        state: "",
        country: "India",
        pin_code: "",
      })
    } catch (err) {
      setAddressErrors({ form: err.response?.data?.error || err.message || "Failed to save address" })
    } finally {
      setIsSubmittingAddress(false)
    }
  }
  const [totals, setTotals] = useState({
    subTotal: 0,
    deliveryCharges: 0,
    costWeight: 0,
    paymentGWCharges: 0,
  })

  // Fetch addresses, products, and delivery state data
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const [addressRes, productRes, allowAddressRes, ChargeRes] =
          await Promise.all([
            axios.get("/api/address/user"),
            data === "cart"
              ? axios.get("/api/cart")
              : axios.get(`/api/products/${data}`),
            axios.get("/api/delivery-states/active"),
            axios.get("/api/charges/type/Payment Gateway"),
          ])
        // console.log("Charge", ChargeRes.data)
        setCharge(ChargeRes.data?.amount || "")
        setAllowAddress(allowAddressRes.data || [])
        const decodedAddresses = (addressRes.data || []).map(decodeAddress)
        setAddresses(decodedAddresses)
        if (decodedAddresses.length > 0) {
          setSelectedAddressId(decodedAddresses[0].id)
        } else {
          setShowInlineAddressForm(true)
        }
        console.log(productRes.data.cart)
        const productList =
          data === "cart"
            ? productRes.data.cart.map((item) => ({
                id: item.product_id,
                cart_item_id: item.id,
                name: item.Product?.name || "Product",
                price: item.Product?.rate || "0.00",
                stock: item.Product?.stock || 0,
                weight: item.Product?.weight || 0,
                gst: item.Product?.product_category?.gst || 0,
                description: item.Product?.description || "",
                product_category: item.Product?.product_category?.name || "",
                image: `${
                  import.meta.env.VITE_BACKEND_URL
                }/public/images/products/${
                  item.Product?.product_images?.[0]?.image_url || ""
                }`,
                qty: parseInt(item.qty, 10) || 1,
              }))
            : [
                {
                  id: productRes.data.product.id,
                  name: productRes.data.product.name,
                  price: productRes.data.product.rate,
                  stock: productRes.data.product.stock,
                  weight: productRes.data.product.weight,
                  gst: productRes.data.product.product_category.gst,
                  description: productRes.data.product.description,
                  product_category:
                    productRes.data.product.product_category.name,
                  image: `${
                    import.meta.env.VITE_BACKEND_URL
                  }/public/images/products/${
                    productRes.data.product.product_images[0].image_url
                  }`,
                  qty: 1,
                },
              ]
        console.log("data", productList)
        setProducts(productList)
        calculateTotal(productList)
      } catch (err) {
        if (err.response?.status === 401) {
          signOut()
        }
        setError(err.response?.data?.message || err.message || "Failed to load order summary")
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [data])

  // Calculate subtotal & total weight
  const calculateTotal = (productList) => {
    let rawSubTotal = 0
    let totalGst = 0

    productList.forEach((item) => {
      const qty = parseInt(item.qty, 10) || 1
      const rate = parseFloat(item.price) * qty
      const gstVal = (rate * parseFloat(item.gst || 0)) / 100
      rawSubTotal += rate
      totalGst += gstVal
    })

    const subTotal = rawSubTotal + totalGst

    let costWeight = productList.reduce(
      (sum, item) => sum + parseFloat(item.weight || 0) * (parseInt(item.qty, 10) || 1),
      0
    )
    costWeight = Math.max(costWeight - 500, 0)

    setTotals((prev) => ({ ...prev, subTotal, rawSubTotal, totalGst, costWeight }))
  }

  // Calculate delivery charges when address or total weight changes
  useEffect(() => {
    const calculateDeliveryCharges = () => {
      if (!selectedAddressId) return 0
      const address = addresses.find((x) => x.id === selectedAddressId)
      const deliveryRate = allowAddress.find((x) => x.name === address?.state)
      if (!deliveryRate) return 0

      let charge = parseFloat(deliveryRate.delivery_rate)
      if (totals.costWeight >= 200) {
        charge +=
          Math.floor(totals.costWeight / 200) * deliveryRate.additional_rate
      }
      return charge
    }

    const deliveryCharges = calculateDeliveryCharges()

    const paymentGWBase = totals.subTotal + deliveryCharges
    let pgCharges = 0
    let pgGST = 0
    if (charge === "") {
      pgCharges = 0
      pgGST = 0
    } else {
      if (charge.includes("%")) {
        let chargeAmount = charge.replace("%", "")
        // console.log("chargeAmount", chargeAmount)

        pgCharges = (paymentGWBase * chargeAmount) / 100
        pgGST = (pgCharges * 18) / 100
      } else {
        pgCharges = parseFloat(charge)
        // pgGST = (pgCharges * 18) / 100
      }
    }
    // pgCharges = (paymentGWBase * 2) / 100
    // pgGST = (pgCharges * 18) / 100
    const paymentGWCharges = pgCharges + pgGST

    setTotals((prev) => ({
      ...prev,
      deliveryCharges,
      paymentGWCharges,
    }))
  }, [
    selectedAddressId,
    totals.costWeight,
    totals.subTotal,
    addresses,
    allowAddress,
  ])

  const handleQtyChange = (index, value) => {
    const updatedProducts = [...products]
    updatedProducts[index].qty = value
    setProducts(updatedProducts)
    calculateTotal(updatedProducts)
  }

  const handleQtyBlur = async (index, value) => {
    const parsedQty = parseInt(value, 10)
    const validQty = isNaN(parsedQty) || parsedQty < 1 ? 1 : parsedQty
    const targetItem = products[index]

    const updatedProducts = [...products]
    updatedProducts[index].qty = validQty
    setProducts(updatedProducts)
    calculateTotal(updatedProducts)

    if (data === "cart" && targetItem?.cart_item_id) {
      try {
        await dispatch(
          updateCartQty({
            cartItemId: targetItem.cart_item_id,
            qty: validQty,
          })
        )
      } catch (err) {
        console.error("Failed to update cart quantity on backend:", err)
      }
    }
  }

  const handleRemoveProduct = async (index, item) => {
    if (products.length <= 1) return
    const updatedProducts = products.filter((_, i) => i !== index)
    setProducts(updatedProducts)
    calculateTotal(updatedProducts)

    if (data === "cart" && item.cart_item_id) {
      try {
        await dispatch(removeCartItem(item.cart_item_id))
      } catch (err) {
        console.error("Failed to remove item from backend cart:", err)
      }
    }
  }

  const handleAddressSelect = (addressId) => {
    setSelectedAddressId(addressId)
  }

  const isOrderValid = useMemo(() => {
    // const validStock = products.every((item) => item.qty <= item.stock)
    const validStock = products.every(
      (item) => item.qty && item.qty <= item.stock
    )
    const validAddress =
      selectedAddressId &&
      allowAddress.find(
        (x) =>
          x.name ===
          addresses.find((addr) => addr.id === selectedAddressId)?.state
      )
    return validStock && validAddress
  }, [products, selectedAddressId, addresses, allowAddress])

  const handleConfirmOrder = async () => {
    // const orderData = {
    //   products: products.map((item) => ({
    //     product_id: item.id,
    //     qty: item.qty,
    //   })),
    //   address_id: selectedAddressId,
    //   //
    // }
    setIsClicked(true)
    if (data === "cart") {
      await initiatePayment(null, 1, selectedAddressId)
    } else if (products.length === 1) {
      await initiatePayment(
        products[0]?.id,
        products[0]?.qty,
        selectedAddressId
      )
    } else {
      await initiatePayment(null, 1, selectedAddressId)
    }
    setTimeout(() => {
      setIsClicked(false)
    }, 6000)

    // console.log("Confirming order:", orderData)

    // await axios.post("/api/orders", orderData)
  }

  return (
    <Page title="Order Summary" searchDisabled={true}>
      {loading || isPlacingOrder ? (
        <div style={{ height: "calc(100svh - 100px)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "16px" }}>
          <Loader />
          {isPlacingOrder && (
            <p style={{ fontWeight: 600, color: "#21170e", fontSize: "1.1rem" }}>
              Processing your order, please wait...
            </p>
          )}
        </div>
      ) : error ? (
        <div className={style.error}>{error}</div>
      ) : (
        <div className={style.checkoutContainer}>
          <div className={style.checkoutGrid}>
            {/* Left Column: Address Selection & Products */}
            <div className={style.mainColumn}>
              {/* Address Section */}
              <section className={style.cardSection}>
                <div className={style.sectionHeader}>
                  <span className={style.stepBadge}>1</span>
                  <h3>Delivery Address</h3>
                </div>

                {addresses.length === 0 && !showInlineAddressForm ? (
                  <div style={{ textAlign: "center", padding: "16px 0" }}>
                    <p style={{ marginBottom: "14px", color: "#64748b" }}>
                      No saved address found. Please add a shipping address to continue.
                    </p>
                    <button
                      type="button"
                      onClick={() => setShowInlineAddressForm(true)}
                      className={style.addAddressBtn}
                    >
                      + Add Delivery Address
                    </button>
                  </div>
                ) : !showInlineAddressForm ? (
                  <div className={style.addressGrid}>
                    {addresses.map((item) => {
                      const isSelected = selectedAddressId === item.id
                      const targetState = decodeHtml(item.state).trim().toLowerCase()
                      const isDeliverable = allowAddress.some(
                        (x) => decodeHtml(x.name).trim().toLowerCase() === targetState || x.name === item.state
                      )

                      return (
                        <div
                          key={item.id}
                          className={`${style.addressCard} ${
                            isSelected ? style.selectedAddressCard : ""
                          }`}
                          onClick={() => handleAddressSelect(item.id)}
                        >
                          <div className={style.addressCardHeader}>
                            <div className={style.addressRadio}>
                              <input
                                type="radio"
                                name="delivery_address"
                                checked={isSelected}
                                onChange={() => handleAddressSelect(item.id)}
                              />
                              <h4>{decodeHtml(item.name)}</h4>
                            </div>
                            {isSelected && (
                              <span className={style.selectedTag}>Selected</span>
                            )}
                          </div>
                          <div className={style.addressDetails}>
                            <p>
                              {[decodeHtml(item.line_1), decodeHtml(item.line_2)].filter(Boolean).join(", ")}
                            </p>
                            <p>
                              {decodeHtml(item.city)}, {decodeHtml(item.district)}, {decodeHtml(item.state)} - {item.pin_code}
                            </p>
                            <p className={style.phoneRow}>
                              📞 Phone: {item.phone_number}
                            </p>
                          </div>
                          {!isDeliverable && (
                            <div className={style.noDeliveryBanner}>
                              ⚠️ Delivery is currently unavailable to this state ({decodeHtml(item.state)}).
                            </div>
                          )}
                        </div>
                      )
                    })}
                    <button
                      type="button"
                      onClick={() => setShowInlineAddressForm(true)}
                      className={style.addAddressOutlineBtn}
                    >
                      + Add New Delivery Address
                    </button>
                  </div>
                ) : null}

                {/* Inline Address Creation Form */}
                {showInlineAddressForm && (
                  <form
                    onSubmit={handleInlineAddressSubmit}
                    className={style.inlineAddressCard}
                  >
                    <h4 className={style.inlineAddressHeader}>📍 Add Delivery Address</h4>
                    {addressErrors.form && (
                      <p className={style.errorMessage}>
                        ⚠️ {addressErrors.form}
                      </p>
                    )}
                    <div className={style.formGrid}>
                      <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>Full Name *</label>
                        <input
                          type="text"
                          name="name"
                          value={newAddressData.name}
                          onChange={handleAddressInputChange}
                          placeholder="e.g. John Doe"
                          className={`${style.fieldInput} ${
                            addressErrors.name ? style.fieldInputError : ""
                          }`}
                        />
                        {addressErrors.name && (
                          <span className={style.errorMessage}>
                            {addressErrors.name}
                          </span>
                        )}
                      </div>

                      <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>Phone Number *</label>
                        <input
                          type="text"
                          name="phone_number"
                          value={newAddressData.phone_number}
                          onChange={handleAddressInputChange}
                          placeholder="10-digit mobile number"
                          className={`${style.fieldInput} ${
                            addressErrors.phone_number ? style.fieldInputError : ""
                          }`}
                        />
                        {addressErrors.phone_number && (
                          <span className={style.errorMessage}>
                            {addressErrors.phone_number}
                          </span>
                        )}
                      </div>

                      <div className={style.fieldGroupFull}>
                        <label className={style.fieldLabel}>Flat / House / Building *</label>
                        <input
                          type="text"
                          name="line_1"
                          value={newAddressData.line_1}
                          onChange={handleAddressInputChange}
                          placeholder="Flat/House No., Building Name"
                          className={`${style.fieldInput} ${
                            addressErrors.line_1 ? style.fieldInputError : ""
                          }`}
                        />
                        {addressErrors.line_1 && (
                          <span className={style.errorMessage}>
                            {addressErrors.line_1}
                          </span>
                        )}
                      </div>

                      <div className={style.fieldGroupFull}>
                        <label className={style.fieldLabel}>Street / Area / Landmark *</label>
                        <input
                          type="text"
                          name="line_2"
                          value={newAddressData.line_2}
                          onChange={handleAddressInputChange}
                          placeholder="Street, Landmark"
                          className={`${style.fieldInput} ${
                            addressErrors.line_2 ? style.fieldInputError : ""
                          }`}
                        />
                        {addressErrors.line_2 && (
                          <span className={style.errorMessage}>
                            {addressErrors.line_2}
                          </span>
                        )}
                      </div>

                      <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>City *</label>
                        <input
                          type="text"
                          name="city"
                          value={newAddressData.city}
                          onChange={handleAddressInputChange}
                          placeholder="City"
                          className={`${style.fieldInput} ${
                            addressErrors.city ? style.fieldInputError : ""
                          }`}
                        />
                        {addressErrors.city && (
                          <span className={style.errorMessage}>
                            {addressErrors.city}
                          </span>
                        )}
                      </div>

                      <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>District *</label>
                        <input
                          type="text"
                          name="district"
                          value={newAddressData.district}
                          onChange={handleAddressInputChange}
                          placeholder="District"
                          className={`${style.fieldInput} ${
                            addressErrors.district ? style.fieldInputError : ""
                          }`}
                        />
                        {addressErrors.district && (
                          <span className={style.errorMessage}>
                            {addressErrors.district}
                          </span>
                        )}
                      </div>

                      <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>State *</label>
                        <select
                          name="state"
                          value={newAddressData.state}
                          onChange={handleAddressInputChange}
                          className={`${style.fieldSelect} ${
                            addressErrors.state ? style.fieldSelectError : ""
                          }`}
                        >
                          <option value="">Select State</option>
                          {allowAddress.map((st) => (
                            <option key={st.id} value={st.name}>
                              {decodeHtml(st.name)}
                            </option>
                          ))}
                        </select>
                        {addressErrors.state && (
                          <span className={style.errorMessage}>
                            {addressErrors.state}
                          </span>
                        )}
                      </div>

                      <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>Pin Code *</label>
                        <input
                          type="number"
                          name="pin_code"
                          value={newAddressData.pin_code}
                          onChange={handleAddressInputChange}
                          placeholder="6-digit Pin Code"
                          className={`${style.fieldInput} ${
                            addressErrors.pin_code ? style.fieldInputError : ""
                          }`}
                        />
                        {addressErrors.pin_code && (
                          <span className={style.errorMessage}>
                            {addressErrors.pin_code}
                          </span>
                        )}
                      </div>

                      <div className={style.fieldGroup}>
                        <label className={style.fieldLabel}>Country *</label>
                        <input
                          type="text"
                          name="country"
                          value={newAddressData.country}
                          onChange={handleAddressInputChange}
                          placeholder="Country"
                          className={`${style.fieldInput} ${
                            addressErrors.country ? style.fieldInputError : ""
                          }`}
                        />
                        {addressErrors.country && (
                          <span className={style.errorMessage}>
                            {addressErrors.country}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className={style.formActions}>
                      <button
                        type="submit"
                        disabled={isSubmittingAddress}
                        className={style.saveBtn}
                      >
                        {isSubmittingAddress ? "Saving..." : "Save & Deliver Here"}
                      </button>
                      {addresses.length > 0 && (
                        <button
                          type="button"
                          onClick={() => {
                            setShowInlineAddressForm(false)
                            setAddressErrors({})
                          }}
                          className={style.cancelBtn}
                        >
                          Cancel
                        </button>
                      )}
                    </div>
                  </form>
                )}
              </section>

              {/* Products Section */}
              <section className={style.cardSection}>
                <div className={style.sectionHeader}>
                  <span className={style.stepBadge}>2</span>
                  <h3>Order Items ({products.length})</h3>
                </div>
                <div className={style.productList}>
                  {products.map((item, index) => (
                    <div key={item.id} className={style.productItemCard}>
                      <div className={style.productImage}>
                        <img src={item.image} alt={item.name} />
                      </div>
                      <div className={style.productDetails}>
                        <div className={style.productInfoRow}>
                          <div>
                            <h4 className={style.productTitle}>{item.name}</h4>
                            {item.product_category && (
                              <span className={style.categoryTag}>{item.product_category}</span>
                            )}
                          </div>
                          {products.length > 1 && (
                            <button
                              type="button"
                              onClick={() => handleRemoveProduct(index, item)}
                              className={style.deleteBtn}
                              title="Remove item"
                              aria-label="Remove item"
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                              </svg>
                            </button>
                          )}
                        </div>

                        <div className={style.productActionRow}>
                          <div className={style.qtyRow}>
                            <span className={style.qtyLabel}>Qty:</span>
                            <div className={style.qtyContainer}>
                              <button
                                type="button"
                                disabled={parseInt(item.qty, 10) <= 1}
                                onClick={() => handleQtyBlur(index, (parseInt(item.qty, 10) || 1) - 1)}
                                className={style.qtyBtn}
                                title="Decrease quantity"
                              >
                                -
                              </button>
                              <input
                                type="number"
                                value={item.qty}
                                min={1}
                                onChange={(e) => handleQtyChange(index, e.target.value)}
                                onBlur={(e) => handleQtyBlur(index, e.target.value)}
                                className={style.qtyInput}
                                placeholder="1"
                              />
                              <button
                                type="button"
                                onClick={() => handleQtyBlur(index, (parseInt(item.qty, 10) || 1) + 1)}
                                className={style.qtyBtn}
                                title="Increase quantity"
                              >
                                +
                              </button>
                            </div>
                          </div>

                          <div className={style.productPriceBox}>
                            <span className={style.unitPrice}>₹{parseFloat(item.price).toFixed(2)} each</span>
                            <span className={style.totalItemPrice}>
                              ₹{(
                                parseFloat(item.price) * (parseInt(item.qty, 10) || 1) +
                                (parseFloat(item.price) * (parseInt(item.qty, 10) || 1) * item.gst) / 100
                              ).toFixed(2)}
                            </span>
                          </div>
                        </div>

                        {item.qty > item.stock && (
                          <p className={style.stockError}>
                            ⚠️ Only {item.stock} in stock
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>

            {/* Right Column: Order Summary Card */}
            <div className={style.sidebarColumn}>
              <div className={style.summaryCard}>
                <div className={style.sectionHeader}>
                  <span className={style.stepBadge}>3</span>
                  <h3>Order Summary</h3>
                </div>

                <div className={style.summaryRows}>
                  <div className={style.summaryRow}>
                    <span>Items Subtotal</span>
                    <span>₹{(totals.rawSubTotal || totals.subTotal).toFixed(2)}</span>
                  </div>

                  {totals.totalGst > 0 && (
                    <div className={style.summaryRow}>
                      <span>GST (Included / Applicable)</span>
                      <span>₹{totals.totalGst.toFixed(2)}</span>
                    </div>
                  )}

                  <div className={style.summaryRow}>
                    <span>Delivery Charges</span>
                    <span>
                      {totals.deliveryCharges > 0 ? `₹${totals.deliveryCharges.toFixed(2)}` : "Free"}
                    </span>
                  </div>

                  {totals.paymentGWCharges > 0 && (
                    <div className={style.summaryRow}>
                      <span>Transaction Fee</span>
                      <span>₹{totals.paymentGWCharges.toFixed(2)}</span>
                    </div>
                  )}

                  <div className={`${style.summaryRow} ${style.grandTotalRow}`}>
                    <span>Grand Total</span>
                    <span className={style.grandTotalAmount}>
                      ₹{(
                        totals.subTotal +
                        totals.deliveryCharges +
                        totals.paymentGWCharges
                      ).toFixed(2)}
                    </span>
                  </div>
                </div>

                {/* Terms Checkbox */}
                <div className={style.termsBox}>
                  <label className={style.termsLabel}>
                    <input
                      type="checkbox"
                      checked={agreedToTerms}
                      onChange={() => setAgreedToTerms(!agreedToTerms)}
                    />
                    <span>
                      I agree to the{" "}
                      <button
                        type="button"
                        className={style.termsLinkBtn}
                        onClick={() => setShowTerms(true)}
                      >
                        Terms & Conditions
                      </button>
                    </span>
                  </label>
                </div>

                {/* Confirm Order Button */}
                <div className={style.buttonArea}>
                  <button
                    onClick={handleConfirmOrder}
                    disabled={!isOrderValid || isClicked || !agreedToTerms}
                    className={style.confirmButton}
                  >
                    {isClicked ? "Processing Order..." : "Confirm Order & Pay"}
                  </button>

                  {!isOrderValid && (
                    <p className={style.validationError}>
                      ⚠️ Please check quantities & select a valid delivery address.
                    </p>
                  )}
                </div>

                <div className={style.trustBadgesBox}>
                  <span>🔒 256-bit Encrypted</span>
                  <span>🌿 100% Authentic</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showTerms && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => setShowTerms(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              width: "90%",
              maxHeight: "80vh",
              overflowY: "scroll",
              borderRadius: "8px",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowTerms(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "transparent",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              &times;
            </button>

            {/* Terms & Conditions content (paste full HTML version here) */}
            <div style={{ fontFamily: "Arial, sans-serif", fontSize: "14px" }}>
              <h2>Customer Terms & Conditions</h2>
              <p>
                <strong>Please read carefully before placing an order.</strong>
              </p>
              <h3>1. Product Nature & Returns</h3>
              <ul>
                <li>
                  Health and Personal Care products are{" "}
                  <strong>non-returnable</strong>.
                </li>
                <li>
                  Please double-check your order details before confirming.
                </li>
              </ul>
              <h3>2. Refund Policy</h3>
              <ul>
                <li>
                  Refunds apply <strong>only for missing items</strong> and
                  require an <strong>unedited courier opening video</strong> and
                  send to{" "}
                  <a href="mailto:dr.mmherbalsenquiry@gmail.com">
                    dr.mmherbalsenquiry@gmail.com
                  </a>
                  .
                </li>
                <li>
                  Refunds are processed to your original payment method after
                  verification.
                </li>
              </ul>
              <h3>3. Exchanges</h3>
              <ul>
                <li>
                  Exchanges are allowed only for wrong items received, and must
                  be reported <strong>within 24 hours of delivery</strong>.
                </li>
                <li>Return shipping costs are borne by the customer.</li>
              </ul>
              <h3>4. Shipping Policy</h3>
              <ul>
                <li>
                  Orders are shipped within <strong>6–10 business days</strong>{" "}
                  (excluding weekends/holidays).
                </li>
                <li>
                  If the product is not received within 4 days of dispatch,
                  notify us at{" "}
                  <a href="mailto:dr.mmherbalsenquiry@gmail.com">
                    dr.mmherbalsenquiry@gmail.com
                  </a>
                  .
                </li>
                <li>
                  Shipping charges are calculated at checkout and are{" "}
                  <strong>non-refundable</strong>.
                </li>
              </ul>
              <h3>5. Other</h3>
              <ul>
                <li>
                  Only regular priced items are eligible for refunds; sale items
                  are non-refundable.
                </li>
                <li>
                  Incorrect address or failed deliveries due to wrong contact
                  info will not be refunded.
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </Page>
  )
}

export default OrderSummary
